var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentCards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9119 12.5H16.9795C17.358 12.5 17.7553 12.5677 17.9558 12.181C17.983 12.1281 17.9952 12.0518 18 11.9688V11.3863L13.6182 11.3848L13.9119 12.5Z",
    fill: "#315195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44 6.64C7.44 6.28654 7.72654 6 8.08 6H17.36C17.7135 6 18 6.28654 18 6.64V11.76C18 12.1135 17.7135 12.4 17.36 12.4H8.08C7.72654 12.4 7.44 12.1135 7.44 11.76V6.64Z",
    fill: "#3D5C9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0438 8.96572C14.9734 8.88116 14.8961 8.87693 14.7465 8.60779C14.5688 8.28833 14.5732 7.8895 14.743 7.56447C14.8306 7.39673 14.9286 7.29671 15.0482 7.20323C14.9926 7.14637 14.8887 7.09047 14.7932 7.04961C14.4787 6.9162 14.0909 6.93309 13.8054 7.09093C12.9523 7.56258 13.0473 8.67496 13.7994 9.06909C14.0111 9.17992 14.2011 9.21327 14.4777 9.19542C14.6899 9.18181 14.937 9.06439 15.0438 8.96433V8.96572Z",
    fill: "#EA001C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0529 7.20338C15.1307 7.2574 15.1617 7.29452 15.2247 7.36496C15.2395 7.38189 15.2449 7.3927 15.2631 7.41667L15.3586 7.56131C15.5678 7.94279 15.5205 8.40547 15.2557 8.75967C15.1416 8.91236 15.1509 8.87431 15.0539 8.95933C15.1548 9.06032 15.427 9.18527 15.6318 9.19562C15.8995 9.20924 16.1048 9.17915 16.3076 9.06594C17.0986 8.62299 17.1045 7.52846 16.2884 7.0869C15.906 6.87973 15.3276 6.93798 15.0529 7.20338Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0431 8.96571L15.0535 8.96051C15.1509 8.87549 15.1411 8.91354 15.2553 8.76089C15.5201 8.40623 15.5674 7.94397 15.3582 7.56253L15.2627 7.41784C15.244 7.39388 15.2391 7.38261 15.2243 7.36618C15.1613 7.2957 15.1298 7.25861 15.0525 7.20456L15.0481 7.2041C14.9285 7.29712 14.8305 7.39765 14.7429 7.56534C14.5726 7.89042 14.5687 8.28878 14.7463 8.60866C14.896 8.87784 14.9732 8.88207 15.0436 8.96663L15.0431 8.96571Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 8.23961C2 7.88615 2.28654 7.59961 2.64 7.59961H11.92C12.2735 7.59961 12.56 7.88615 12.56 8.23961V13.3596C12.56 13.7131 12.2735 13.9996 11.92 13.9996H2.64C2.28654 13.9996 2 13.7131 2 13.3596V8.23961Z",
    fill: "#1289D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86786 9.85787L8.79107 10.2308C9.06775 10.3229 9.3712 10.3617 9.65819 10.2567C10.0636 10.1082 10.2249 9.61993 9.81172 9.35043C9.77128 9.32409 9.72304 9.29891 9.6746 9.27364C9.60699 9.23836 9.53897 9.20287 9.49124 9.16371C9.35626 9.05353 9.46188 8.93509 9.62726 8.91751C9.77503 8.90145 9.86232 8.93042 9.95767 8.96205C9.98832 8.97222 10.0198 8.98267 10.0544 8.99198L10.1286 8.63403C9.75865 8.49801 9.22181 8.5275 9.02704 8.89836C8.88228 9.17303 9.03787 9.4177 9.2903 9.54957C9.30652 9.55805 9.3245 9.5669 9.34333 9.57617C9.4418 9.62465 9.56394 9.68479 9.58297 9.76425C9.63447 9.98355 9.25169 9.98563 9.06207 9.93026C9.02618 9.9198 8.99457 9.90642 8.96376 9.89338C8.9322 9.88002 8.90148 9.86702 8.86786 9.85787Z",
    fill: "#FDFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16161 8.63854C6.15865 8.63337 6.16012 8.62541 6.16274 8.61117L6.1648 8.59966C6.20359 8.579 6.47439 8.58448 6.63481 8.58805C6.67904 8.58903 6.71488 8.58983 6.73514 8.58983L6.77294 8.58972C6.95692 8.58891 7.08239 8.58836 7.12054 8.77499C7.12921 8.8175 7.14497 8.90859 7.164 9.0186C7.21167 9.29407 7.27987 9.6882 7.30859 9.73551L7.76144 8.58983L8.22358 8.59085L7.50642 10.2926L7.05044 10.2931C7.0277 10.2479 6.87924 9.66012 6.81026 9.38701L6.77996 9.26743L6.71158 9.00233C6.66039 8.8041 6.65645 8.78885 6.37809 8.69793C6.28689 8.66822 6.23253 8.65788 6.20088 8.65186C6.17623 8.64717 6.16535 8.6451 6.16161 8.63854Z",
    fill: "#FDFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.482 10.2923L10.0286 10.2903L10.4562 9.26093C10.485 9.19148 10.5139 9.12364 10.5426 9.05621C10.5868 8.95237 10.6306 8.84948 10.6731 8.74316C10.7118 8.64696 10.7566 8.59109 10.8838 8.5885C10.9982 8.58643 11.1352 8.58439 11.2491 8.59007L11.6 10.2918L11.1976 10.2929L11.1435 10.0379L10.5783 10.0374C10.5729 10.0528 10.5667 10.0712 10.56 10.0911C10.537 10.1597 10.5079 10.2462 10.482 10.2923ZM10.94 9.06129C10.8993 9.11042 10.7118 9.67734 10.7102 9.68873L11.0667 9.68818L10.94 9.06129Z",
    fill: "#FDFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48541 10.2922L8.04904 10.2911L8.4143 8.58936H8.85273L8.48541 10.2922Z",
    fill: "#FDFFFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -1,
    y: 1.59961,
    width: 20.56,
    height: 16.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCards);
export default __webpack_public_path__ + "static/media/payment_cards.78cfcc2c9bf2af1e277eea11f3ad680c.svg";
export { ForwardRef as ReactComponent };